import {InputSelectIcon} from "./@CustomIcons";
import {alpha} from "@mui/material/styles";

const overrideSelectStyles = () => ({
    MuiSelect: {
        defaultProps: {
            IconComponent: InputSelectIcon
        },

        styleOverrides: {
            root: {
                "&.focused, &:not(:has(.notranslate))": {
                    legend: {
                        maxWidth: "100%"
                    }
                }
            }
        }
    }
})

export default overrideSelectStyles